import { render, staticRenderFns } from "./ForumWysiwyg.vue?vue&type=template&id=9c82bcf4&lang=pug"
import script from "./ForumWysiwyg.vue?vue&type=script&lang=ts"
export * from "./ForumWysiwyg.vue?vue&type=script&lang=ts"
import style0 from "./ForumWysiwyg.vue?vue&type=style&index=0&id=9c82bcf4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports